import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function common() {
document.body.setAttribute('tabindex', '0');


const $commonWindow = $(window);
window.rwdType = '';

const initWindowRwdType = function () {
  const windowWidth = window.innerWidth;
  if (windowWidth >= 1280) {
    window.rwdType = 'large';
  } else if (windowWidth > 731 && windowWidth < 1280) {
    window.rwdType = 'medium';
  } else {
    window.rwdType = 'small';
  }
  console.log('* Window rwdType *', window.rwdType);
}

const commonScrollTriggers = function () {

  const $detectDom = $('.section__base .animate-player');
  
  $detectDom.each(function(index) {
    let $this = $(this);

    // 使用GSAP ScrollTrigger替代Waypoint
    gsap.timeline({
      scrollTrigger: {
        trigger: $this,
        start: 'top 60%',
        onEnter: () => {
          setTimeout(() => {
            $this.addClass('fadeIn');
            setTimeout(() => {
                $this.addClass('animated');
            }, 300);
          }, 300);
        },
        onLeaveBack: () => {
          // 你可以根據需要在這裡處理返回滾動事件
        },
      }
    });
  });
}

const commonScrollTriggerWaypoints = function () {
  const $detectDom = $('.section__base');

  $detectDom.each(function(index) {
    let $this = $(this);

    gsap.timeline({
      scrollTrigger: {
        trigger: $this,
        start: 'top 0%',
        onEnter: () => {
          if ($this.hasClass('scroll-refresh')) {
            ScrollTrigger.refresh();
            console.log('ScrollTrigger Refresh!!');
          }
        },
        onLeaveBack: () => {
          // 你可以根據需要在這裡處理返回滾動事件
        },
        // 如果不需要監聽返回滾動，可以直接用once: true來代替onLeaveBack
        // once: true
      }
    });
  });
}

commonScrollTriggers();
commonScrollTriggerWaypoints();

initWindowRwdType();

$commonWindow.on('resize', function() {
  initWindowRwdType();
})

}